import React from "react";
import { Modal } from "antd";
import FaiButton from "MuiComponents/FaiButton";
import appStore from "store/general";

const ConfirmModal = ({
	title = null,
	message = "",
	body = null,
	visible = false,
	footer = true,
	handleOk = async () => {},
	handleCancel = async () => {},
	primaryBtnText = "Yes",
	secondaryBtnText = "No",
	className = "",
}) => {
	const { setConfirmModal }: any = appStore();

	const onDone = async () => {
		await handleOk();
		setConfirmModal();
	};

	const onCancel = async () => {
		await handleCancel();
		setConfirmModal();
	};

	return (
		<Modal
			title={title || "Confirm Deletion"}
			visible={visible}
			onCancel={onCancel}
			className={className}
			footer={
				footer && [
					<FaiButton color="primary" onClick={onDone}>
						{primaryBtnText}
					</FaiButton>,
					<FaiButton onClick={onCancel}>{secondaryBtnText}</FaiButton>,
				]
			}
			classNames={{
				header: "text-center",
				body: "text-center",
				footer: "flex justify-center gap-5",
			}}
			styles={{
				header: {},
			}}
		>
			{body ??
				(message ||
					"Are you sure you want to delete this draft listing? This action cannot be undone.")}
		</Modal>
	);
};

export default ConfirmModal;
